<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path d="M15.9,5.9c-.5-2.7-3.2-3-3.2-3H.5c-.4,0-.5.6-.5.6C0,3.4,0,8.3,0,11.3c.1,1.6,1.7,1.8,1.7,1.8h7.9c1.6-.3,1.8-1.7,1.8-2.5,2.9.1,4.9-1.9,4.4-4.6h0ZM8.6,8.3c-.8.9-2.7,2.7-2.7,2.7,0,0,0,.1-.2,0h0c-.3-.4-2.2-2.1-2.7-2.7-.5-.7-.7-1.8,0-2.4.7-.7,2-.7,2.9.2,0,0,1.1-1.2,2.3-.7,1.2.6,1.2,2,.5,2.8h0ZM12.7,8.6c-.6.1-1.1,0-1.1,0v-3.8h1.2s1.3.3,1.3,1.8-.6,1.8-1.4,2h0Z"/>
  </svg>
</template>
